import { render, staticRenderFns } from "./ReportPush.vue?vue&type=template&id=24b5d62e&scoped=true&"
import script from "./ReportPush.vue?vue&type=script&lang=js&"
export * from "./ReportPush.vue?vue&type=script&lang=js&"
import style0 from "./ReportPush.vue?vue&type=style&index=0&id=24b5d62e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b5d62e",
  null
  
)

export default component.exports